/**
 * Family Detail Page
 */

import { FolderTree } from 'lucide-react'
import { CatalogDetailPage } from './CatalogDetailPage'
import { useTranslation } from '@/hooks/useTranslation'

export function FamilyDetailPage() {
  const { t } = useTranslation()

  return (
    <CatalogDetailPage
      config={{
        endpoint: 'families',
        basePath: '/families',
        title: t('catalogs.families'),
        editLabel: t('catalogs.editFamily'),
        icon: FolderTree,
        fields: [
          { key: 'code', label: t('articles.code') },
          { key: 'description', label: t('articles.description') },
        ],
      }}
    />
  )
}
